// Keeps the last saved deck in this browser, so it's still the play deck after a refresh or next visit.
// Export/Import still work as before (for moving a deck to another computer or keeping several).
import { deckProblems, type Deck } from '../shared/deck.ts';
import { CARD_DB } from './data.ts';
import { session } from './session.ts';

const KEY = 'arellix.savedDeck';

/** Store the deck that Save Deck just made the play deck. */
export function rememberSavedDeck(deck: Deck, name: string) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ name, cards: [...deck] }));
  } catch {
    // no storage here (a private window): the deck lasts until the page is closed, as before
  }
}

/** Put the remembered deck back as the play deck (called once as the game starts). */
export function restoreSavedDeck() {
  let data: { name?: unknown; cards?: unknown } | null = null;
  try {
    data = JSON.parse(localStorage.getItem(KEY) ?? 'null');
  } catch {
    return;
  }
  if (!data || !Array.isArray(data.cards)) return;
  const deck: Deck = new Map();
  for (const pair of data.cards) {
    if (Array.isArray(pair) && Number.isInteger(pair[0]) && Number.isInteger(pair[1]) && pair[1] > 0) deck.set(pair[0], pair[1]);
  }
  if (deck.size === 0) return;
  const name = typeof data.name === 'string' ? data.name : '';
  // An update may have changed the cards (one removed, a copy limit lowered). Then the deck can't be played
  // as it is: it waits in the Deck Builder to be fixed and saved again instead.
  if (deckProblems(deck, CARD_DB).length === 0) {
    session.savedDeck = deck;
    session.savedDeckName = name;
  }
  session.workingDeck = new Map(deck);
  session.workingDeckName = name;
}
